export default {
      id: "icon-wetlands-usage",
      viewBox: "0 0 48.518 73.283",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-wetlands",
      toString: function () {
        return this.url;
      }
    }